import { render, staticRenderFns } from "./InquiryList.vue?vue&type=template&id=c1560e54&scoped=true&"
import script from "./InquiryList.vue?vue&type=script&lang=js&"
export * from "./InquiryList.vue?vue&type=script&lang=js&"
import style0 from "./InquiryList.vue?vue&type=style&index=0&id=c1560e54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1560e54",
  null
  
)

export default component.exports